var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "side-menu-left" }, [
    _c(
      "div",
      { staticClass: "top-menu-logo" },
      [
        _vm.currentYear === 2024
          ? _c("RouterLink", { attrs: { to: "/" } }, [
              _c("img", {
                staticClass: "d-logo businessLogo",
                attrs: {
                  src: "/static/front/images/menu-images/b1g1-logo-cap.svg",
                  alt: "alt"
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "d-logo personalLogo",
                attrs: {
                  src: "/static/front/images/menu-images/b1g1-logo-2-cap.svg",
                  alt: "alt"
                }
              })
            ])
          : _c("RouterLink", { attrs: { to: "/" } }, [
              _c("img", {
                staticClass: "d-logo businessLogo",
                attrs: {
                  src: "/static/front/images/menu-images/b1g1-logo.svg",
                  alt: "alt"
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "d-logo personalLogo",
                attrs: {
                  src: "/static/front/images/menu-images/b1g1-logo-2.svg",
                  alt: "alt"
                }
              })
            ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.user.account === "company"
      ? _c("div", { staticClass: "profile-wrapper" }, [
          _c("div", { staticClass: "notification-wrapper" }, [
            _c("span", [_vm._v(_vm._s(_vm.companyName.charAt(0)))]),
            _vm._v(" "),
            _c("div", { staticClass: "noti-wrapper" }, [
              _c("div", { staticClass: "Company-Account" }, [
                _vm._v("Company Account")
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "user-neme" }, [
                _vm._v(
                  _vm._s(
                    _vm.companyName.length > 25
                      ? _vm.companyName.substr(0, 25) + "..."
                      : _vm.companyName
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "Impacts-Created" }, [
                _c("div", [_vm._v(_vm._s(_vm.totalImpacts))]),
                _vm._v(" Impacts Created")
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.user.account !== "company"
      ? _c("div", { staticClass: "profile-wrapper" }, [
          _c("div", { staticClass: "notification-wrapper" }, [
            _c("span", [_vm._v(_vm._s(_vm.user.first_name.charAt(0)))]),
            _vm._v(" "),
            _c("div", { staticClass: "noti-wrapper" }, [
              _c("div", { staticClass: "Company-Account" }, [
                _vm._v("Personal Account")
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "user-neme" }, [
                _vm._v(
                  _vm._s(
                    _vm.user.first_name.length > 25
                      ? _vm.user.first_name.substr(0, 25) + "..."
                      : _vm.user.first_name
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "Impacts-Created" }, [
                _c("div", [_vm._v(_vm._s(_vm.totalImpacts))]),
                _vm._v(" Impacts Created")
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "menu-item" },
      [
        [
          _c("div", [
            _c("nav", { staticClass: "navbar" }, [
              _c("ul", [
                _c(
                  "li",
                  {
                    class: {
                      "menu-list-wrapper": true,
                      "menu-list-active": _vm.isActiveRoute(["/", "/impact"])
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "menu-wrapper",
                        on: { click: _vm.goToDashboard }
                      },
                      [
                        _c("div", { staticClass: "menu-icon" }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.left",
                                  value: {
                                    content: "Dashboard",
                                    class: "normal-tooltip sidebar-menu-tooltip"
                                  },
                                  expression:
                                    "{ content: 'Dashboard', class: 'normal-tooltip sidebar-menu-tooltip' }",
                                  modifiers: { left: true }
                                }
                              ],
                              staticClass: "infopop",
                              attrs: {
                                "data-container": "body",
                                "data-toggle": "popover"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    "/static/front/images/menu-images/dashboard-icon.svg",
                                  alt: ""
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "RouterLink",
                          {
                            staticClass: "primery-menu-link",
                            attrs: { to: "/" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.closeMenu.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Dashboard")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: {
                      "menu-list-wrapper": true,
                      "menu-list-active": _vm.isActiveRoute([
                        "/view-all-projects",
                        "/engagement-tool",
                        "/recurring-impacts",
                        "/create-recurring-impacts"
                      ])
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "menu-wrapper",
                        on: { click: _vm.openIconDropDown }
                      },
                      [
                        _c("div", { staticClass: "menu-icon" }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.right",
                                  value: {
                                    content: "Create Impacts",
                                    class: "normal-tooltip sidebar-menu-tooltip"
                                  },
                                  expression:
                                    "{ content: 'Create Impacts', class: 'normal-tooltip sidebar-menu-tooltip' }",
                                  modifiers: { right: true }
                                }
                              ],
                              staticClass: "infopop",
                              attrs: {
                                "data-container": "body",
                                "data-toggle": "popover"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    "/static/front/images/menu-images/create-impact-icon.svg",
                                  alt: ""
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "RouterLink",
                          {
                            staticClass: "primery-menu-link active",
                            attrs: { to: "#" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.toggleDropdown.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Create Impacts")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "arrow-down",
                            on: { click: _vm.toggleDropdown }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  "/static/front/images/menu-images/arrow-icon.svg",
                                alt: ""
                              }
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "submenu-list" }, [
                      _c("ul", [
                        _c(
                          "li",
                          [
                            !_vm.isDowngradeUser
                              ? _c(
                                  "RouterLink",
                                  {
                                    attrs: { to: "/view-all-projects" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeMenu.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Explore Project List")]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _vm.isDowngradeUser
                              ? _c(
                                  "RouterLink",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top",
                                        value: {
                                          content:
                                            "Please upgrade your account to access embed codes. Contact us for help.",
                                          class: "normal-tooltip"
                                        },
                                        expression:
                                          "{ content: 'Please upgrade your account to access embed codes. Contact us for help.', class: 'normal-tooltip' }",
                                        modifiers: { top: true }
                                      }
                                    ],
                                    attrs: { to: "/view-all-projects" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeMenu.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Explore Project List")]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _vm.isDowngradeUser
                              ? _c(
                                  "RouterLink",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top",
                                        value: {
                                          content:
                                            "Please upgrade your account to access embed codes. Contact us for help.",
                                          class: "normal-tooltip"
                                        },
                                        expression:
                                          "{ content: 'Please upgrade your account to access embed codes. Contact us for help.', class: 'normal-tooltip' }",
                                        modifiers: { top: true }
                                      }
                                    ],
                                    attrs: { to: "/recurring-impacts" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeMenu.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Create Recurring Impacts")]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            !_vm.isDowngradeUser
                              ? _c(
                                  "RouterLink",
                                  {
                                    attrs: { to: "/recurring-impacts" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeMenu.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Create Recurring Impacts")]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "hideFromPersonalMenu" },
                          [
                            _c(
                              "RouterLink",
                              {
                                attrs: { to: "/engagement-tool" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.closeMenu.apply(null, arguments)
                                  }
                                }
                              },
                              [_vm._v("Enhanced Engagement Tool")]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                !_vm.isDowngradeUser
                  ? _c(
                      "li",
                      {
                        class: {
                          "menu-list-wrapper": true,
                          "menu-list-active": _vm.isActiveRoute([
                            "/impact-history",
                            "/giving-widget"
                          ])
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "menu-wrapper",
                            on: { click: _vm.openIconDropDown }
                          },
                          [
                            _c("div", { staticClass: "menu-icon" }, [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.right",
                                      value: {
                                        content: "Track Your Impacts",
                                        class:
                                          "normal-tooltip sidebar-menu-tooltip"
                                      },
                                      expression:
                                        "{ content: 'Track Your Impacts', class: 'normal-tooltip sidebar-menu-tooltip' }",
                                      modifiers: { right: true }
                                    }
                                  ],
                                  staticClass: "infopop",
                                  attrs: {
                                    "data-container": "body",
                                    "data-toggle": "popover"
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "/static/front/images/menu-images/track-icon.svg",
                                      alt: ""
                                    }
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "RouterLink",
                              {
                                staticClass: "primery-menu-link",
                                attrs: { to: "#" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.toggleDropdown.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [_vm._v("Track Your Impacts")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "arrow-down",
                                on: { click: _vm.toggleDropdown }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "/static/front/images/menu-images/arrow-icon.svg",
                                    alt: ""
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "submenu-list" }, [
                          _c("ul", [
                            _c(
                              "li",
                              [
                                _c(
                                  "RouterLink",
                                  {
                                    attrs: { to: "/impact-history" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeMenu.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("View Impact History")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "d-sm-none hideFromPersonalMenu" },
                              [
                                _c(
                                  "RouterLink",
                                  {
                                    attrs: { to: "/giving-widget" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeMenu.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Embed Impact Widgets")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _c(
                                  "RouterLink",
                                  {
                                    attrs: { to: "/project-updates/list" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeMenu.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Follow Your Impact Updates")]
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.user.user_business &&
                _vm.user.user_business.is_admin &&
                _vm.user.user_business.is_business === 0
                  ? _c(
                      "li",
                      {
                        staticClass: "d-sm-none hideFromPersonalMenu",
                        class: {
                          "menu-list-wrapper": true,
                          "menu-list-active": _vm.isActiveRoute([
                            "/token-management",
                            "/team-accounts-management"
                          ])
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "menu-wrapper",
                            on: { click: _vm.openIconDropDown }
                          },
                          [
                            _c("div", { staticClass: "menu-icon" }, [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.right",
                                      value: {
                                        content: "Team & Tokens",
                                        class:
                                          "normal-tooltip sidebar-menu-tooltip"
                                      },
                                      expression:
                                        "{ content: 'Team & Tokens', class: 'normal-tooltip sidebar-menu-tooltip' }",
                                      modifiers: { right: true }
                                    }
                                  ],
                                  staticClass: "infopop",
                                  attrs: {
                                    "data-container": "body",
                                    "data-toggle": "popover"
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "/static/front/images/menu-images/engage-icon.svg",
                                      alt: ""
                                    }
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "RouterLink",
                              {
                                staticClass: "primery-menu-link",
                                attrs: { to: "#" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.toggleDropdown.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [_vm._v("Team & Tokens")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "arrow-down",
                                on: { click: _vm.toggleDropdown }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "/static/front/images/menu-images/arrow-icon.svg",
                                    alt: ""
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "submenu-list" }, [
                          _c("ul", [
                            _c(
                              "li",
                              { staticClass: "d-sm-none" },
                              [
                                _c(
                                  "RouterLink",
                                  {
                                    attrs: { to: "/token-management" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeMenu.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Manage Impact Tokens")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _c(
                                  "RouterLink",
                                  {
                                    attrs: { to: "/team-accounts-management" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeMenu.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Manage Team Accounts")]
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "d-lg-none hideFromPersonalMenu",
                    class: {
                      "menu-list-wrapper": true,
                      "menu-list-active": _vm.isActiveRoute(["/invite"])
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "menu-wrapper",
                        on: { click: _vm.openIconDropDown }
                      },
                      [
                        _c("div", { staticClass: "menu-icon" }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.right",
                                  value: {
                                    content: "Refer Another Business",
                                    class: "normal-tooltip sidebar-menu-tooltip"
                                  },
                                  expression:
                                    "{ content: 'Refer Another Business', class: 'normal-tooltip sidebar-menu-tooltip' }",
                                  modifiers: { right: true }
                                }
                              ],
                              staticClass: "infopop",
                              attrs: {
                                "data-container": "body",
                                "data-toggle": "popover"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    "/static/front/images/menu-images/share-icon.svg",
                                  alt: ""
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "RouterLink",
                          {
                            staticClass: "primery-menu-link",
                            attrs: {
                              to:
                                _vm.isHivePartner === 1
                                  ? "/hive-builder"
                                  : "/invite"
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.closeMenu.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v(" Refer Another Business")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "d-sm-none hideFromPersonalMenu",
                    class: {
                      "menu-list-wrapper": true,
                      "menu-list-active": _vm.isActiveRoute([
                        "/invite",
                        "/gratitude-certificate",
                        "/media-kit-brand-guideline"
                      ])
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "menu-wrapper",
                        on: { click: _vm.openIconDropDown }
                      },
                      [
                        _c("div", { staticClass: "menu-icon" }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.right",
                                  value: {
                                    content: "Share & Inspire",
                                    class: "normal-tooltip sidebar-menu-tooltip"
                                  },
                                  expression:
                                    "{ content: 'Share & Inspire', class: 'normal-tooltip sidebar-menu-tooltip' }",
                                  modifiers: { right: true }
                                }
                              ],
                              staticClass: "infopop",
                              attrs: {
                                "data-container": "body",
                                "data-toggle": "popover"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    "/static/front/images/menu-images/share-icon.svg",
                                  alt: ""
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "RouterLink",
                          {
                            staticClass: "primery-menu-link",
                            attrs: { to: "#" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.toggleDropdown.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Share & Inspire")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "arrow-down",
                            on: { click: _vm.toggleDropdown }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  "/static/front/images/menu-images/arrow-icon.svg",
                                alt: ""
                              }
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "submenu-list" }, [
                      _c("ul", [
                        _c(
                          "li",
                          [
                            _c(
                              "RouterLink",
                              {
                                attrs: {
                                  to:
                                    _vm.isHivePartner === 1
                                      ? "/hive-builder"
                                      : "/invite"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.closeMenu.apply(null, arguments)
                                  }
                                }
                              },
                              [_vm._v("Refer Other Businesses")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "RouterLink",
                              {
                                attrs: { to: "/gratitude-certificate" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.closeMenu.apply(null, arguments)
                                  }
                                }
                              },
                              [_vm._v("Create Gratitude Certificates")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "RouterLink",
                              {
                                attrs: { to: "/media-kit-brand-guideline" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.closeMenu.apply(null, arguments)
                                  }
                                }
                              },
                              [_vm._v("Media Kit & Other Resources")]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: {
                      "menu-list-wrapper": true,
                      "menu-list-active": _vm.isActiveRoute([
                        "/business-listing",
                        "/impact-partnership",
                        "/impact-partnership-b"
                      ])
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "menu-wrapper",
                        on: { click: _vm.openIconDropDown }
                      },
                      [
                        _c("div", { staticClass: "menu-icon" }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.right",
                                  value: {
                                    content: "Community",
                                    class: "normal-tooltip sidebar-menu-tooltip"
                                  },
                                  expression:
                                    "{ content: 'Community', class: 'normal-tooltip sidebar-menu-tooltip' }",
                                  modifiers: { right: true }
                                }
                              ],
                              staticClass: "infopop",
                              attrs: {
                                "data-container": "body",
                                "data-toggle": "popover"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    "/static/front/images/menu-images/community-icon.svg",
                                  alt: ""
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "RouterLink",
                          {
                            staticClass: "primery-menu-link",
                            attrs: { to: "#" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.toggleDropdown.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Community")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "arrow-down",
                            on: { click: _vm.toggleDropdown }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  "/static/front/images/menu-images/arrow-icon.svg",
                                alt: ""
                              }
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "submenu-list" }, [
                      _c("ul", [
                        _c(
                          "li",
                          [
                            _c(
                              "RouterLink",
                              {
                                attrs: { to: "/events" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.closeMenu.apply(null, arguments)
                                  }
                                }
                              },
                              [_vm._v("Events")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "RouterLink",
                              {
                                attrs: { to: "/business-listing" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.closeMenu.apply(null, arguments)
                                  }
                                }
                              },
                              [_vm._v("Explore Business Listing")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.partner_level === null
                          ? _c(
                              "li",
                              { staticClass: "hideFromPersonalMenu" },
                              [
                                _c(
                                  "RouterLink",
                                  {
                                    attrs: { to: "/impact-partnership" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeMenu.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("My Partnership Status")]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.partner_level !== null
                          ? _c(
                              "li",
                              { staticClass: "hideFromPersonalMenu" },
                              [
                                _c(
                                  "RouterLink",
                                  {
                                    attrs: { to: "/impact-partnership-b" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeMenu.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("My Partnership Status")]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(0)
                      ])
                    ])
                  ]
                )
              ])
            ])
          ])
        ]
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "https://blog.b1g1.com/", target: "_blank" } }, [
        _vm._v("Explore Blog & Stories")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cde53e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cde53e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/menu-custom.vue
// module id = null
// module chunks = 